<!-- =========================================================================================
    File Name: VerticalNavMenuItem.vue
    Description: Vertical NavMenu item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VerticalNavMenuItem
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="vs-sidebar--item"
    :style="{zIndex: zIndex}"
    :class="{'vs-sidebar-item-active' : getActiveLink()}" >
<!--:target="target" -->
<!--    exact 删除掉不包含-->
      <router-link
        exact
        tabindex="-1"
        v-if="menuItem.isFrame"
        :class="{'router-link-active': getActiveLink()}"
        :to="{ name: menuItem.componentName }"
      >
<!--        -->
<!--          <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />-->
<!--          <feather-icon v-else :class="{'w-3 h-3': iconSmall}" :icon="icon" />-->
            <icon-svg
              :icon-class="menuItem.icon"
              class="icon-el"
              :class="{on: getActiveLink()}"
            />
          <slot />
      </router-link>
<!--      跳转外链-->
      <a v-else target="_blank" :href="item.path" tabindex="-1">
<!--        <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />-->
<!--        <feather-icon v-else :class="{'w-3 h-3': iconSmall}" :icon="icon" />-->
        <icon-svg
          :icon-class="menuItem.icon"
          class="icon-el"
          :class="{on: getActiveLink()}"
        />
        <slot />
      </a>
  </div>
</template>

<script>
export default {
  name: 'v-nav-menu-item',
  props: {
    icon        : { type: String,                 default: ""               },
    iconSmall   : { type: Boolean,                default: false            },
    iconPack    : { type: String,                 default: 'material-icons' },
    href        : { type: [String, null],         default: '#'              },
    to          : { type: [String, Object, null], default: null             },
    featherIcon : { type: Boolean,                default: true             },
    zIndex: { },
    menuItem:{
      type: Object,
      default(){
        return {
          componentName: ''
        }
      }
    }
  },
  computed: {

  },
  mounted(){
  },
  methods: {
    getActiveLink() {
      if(this.menuItem.componentName == 'customerManage' && this.$route.name == 'customerDetail'){
        return true;
      }
      if(this.menuItem.componentName == 'apiTurnover' && this.$route.name == 'apiTurnoverDetail'){
        return true;
      }
      return this.menuItem.componentName === this.$route.name;
    }
  },
}

</script>
<style lang="scss" scoped>
  .vs-sidebar--item {
    position: relative;
  }
  .icon-el {
    margin-right: 10px;
    font-size: 14px;
    &.on {
      color: #ffffff;
    }
  }
</style>
<style lang="scss">
  .icon-el {
    font-size: 20px!important;
  }
</style>
